const state = {
    categories: []
}

const mutations = {
    SET_CATEGORIES(state, categories) {
        state.categories = categories;
    }
}

const actions = {
    setCategories({ commit }, categories) {
        commit("SET_CATEGORIES", categories);
    }
}

const getters = {
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
